import React, { useCallback, useState } from 'react';
import { PlusCircle, XCircle } from 'react-bootstrap-icons'

import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';

import SimulationServiceTypeSelect from '../Simulation/SimulationServiceTypeSelect';
import ProviderSelect from '../../dialogs/ProviderSelect';

export default function CashQuote({ handleAPIRequest }) {
    
    const [alertError, setAlertError] = useState(null)
    const [alertSuccess, setAlertSuccess] = useState(null)
    
    const [cashQuoteInput, setCashQuoteInput] = useState({
        serviceTypeCategory: null,
        serviceType: null,
        adultPediatric: 'A',
        providers: []
    });

    const setAdultPediatric = (adultPediatric, serviceType) => {
        if (adultPediatric && serviceType) {
            setCashQuoteInput({
                adultPediatric
            ,   serviceTypeCategory: cashQuoteInput.serviceTypeCategory
            ,   serviceType
            ,   providers: []
            });
        }
        else if (adultPediatric) {
            setCashQuoteInput({
                adultPediatric
            ,   serviceTypeCategory: cashQuoteInput.serviceTypeCategory
            ,   serviceType: cashQuoteInput.serviceType
            ,   providers: []
            });
        }
        else {
            setCashQuoteInput({
                adultPediatric: 'A'
            ,   serviceTypeCategory: cashQuoteInput.serviceTypeCategory
            ,   serviceType: cashQuoteInput.serviceType
            ,   providers: []
            });
        }
    };

    const setServiceTypeCategory = (serviceTypeCategory) => {
        if (serviceTypeCategory) {
            setCashQuoteInput({
                adultPediatric: cashQuoteInput.adultPediatric
            ,   serviceTypeCategory
            ,   serviceType: null
            ,   providers: []
            });
        }
        else {
            setCashQuoteInput({
                adultPediatric: cashQuoteInput.adultPediatric
            ,   serviceTypeCategory: null
            ,   serviceType: null
            ,   providers: []
            });
        }
    };

    const setServiceType = (serviceType) => {
        if (serviceType) {
            setCashQuoteInput({
                adultPediatric: cashQuoteInput.adultPediatric
            ,   serviceTypeCategory: cashQuoteInput.serviceTypeCategory
            ,   serviceType 
            ,   providers: []
            });
        }
        else {
            setCashQuoteInput({
                adultPediatric: cashQuoteInput.adultPediatric
            ,   serviceTypeCategory: cashQuoteInput.serviceTypeCategory
            ,   serviceType: null
            ,   providers: []
            });
        }
    };

    const onProvidersCreate = (providers) => {
        const newProviders = [...cashQuoteInput.providers];
        providers.forEach((provider) => {
            newProviders.push(provider);
        });

        setCashQuoteInput((prev) => ({
            ...prev,
            providers: newProviders
        }));
    };
    
    const onProviderDelete = (provider) => {

        const newProviders = cashQuoteInput.providers.filter((c) => {
            return c.provider_id !== provider.provider_id;
        });

        setCashQuoteInput((prev) => ({
            ...prev,
            providers: newProviders
        }));
    };

    // ************************************************************************
    // Modals ProviderSelect

    const [modal_ProviderSelect_dialog_open, setProviderSelectDialogOpen] = useState(false)

    const onModalProviderSelectDialogOpen = () => {
        setProviderSelectDialogOpen(true);
    }

    // ************************************************************************
    // Submit Cash Quote

    const onSubmitCashQuote = useCallback(() => {
        console.log("Cash Quote Data:", {
            serviceTypeCategory: cashQuoteInput.serviceTypeCategory,
            serviceType: cashQuoteInput.serviceType,
            providers: cashQuoteInput.providers
        });

        const do_post = async () => {
            const res = await handleAPIRequest('/api/v1/send_email', {
                method: 'POST' 
            ,   body: JSON.stringify({
                    to: 'support@healthrate.io',
                    subject: 'Cash Quote',
                    body: `Service Type Category: ${ 
                        cashQuoteInput.serviceTypeCategory?.service_type_category || 'None'
                    }\nService Type: ${
                        cashQuoteInput.serviceType?.service_type || 'None'
                     }\nProviders: ${cashQuoteInput.providers.map(provider => provider.provider).join(', ') || 'None'}`,
                })
            });
            
            if (res.status === 200) {
                setAlertSuccess({
                    title: 'Cash Quote Submitted'
                ,   body: 'Your request has been submitted successfully.'
                });
                setTimeout(() => {setAlertSuccess(null)}, 7000);
                console.log('Cash Quote submitted successfully'); 
            } 
            else { 
                setAlertError({
                    title: 'Error Submitting Cash Quote: ',
                    body: res.statusText
                });
                setTimeout(() => {setAlertError(null)}, 5000);
                console.error('Error submitting Cash Quote', res.statusText);
            }
        }

        do_post();

    }, [handleAPIRequest, cashQuoteInput]);

    return (        
        <>
            <Alert show={!!alertError} variant="danger">
                <Alert.Heading>{alertError ? alertError.title : ''}</Alert.Heading>
                <p dangerouslySetInnerHTML={alertError ? { __html: alertError.body } : { __html: '' }}></p>
            </Alert>

            <Alert show={!!alertSuccess} variant="success">
                <Alert.Heading>{alertSuccess ? alertSuccess.title : ''}</Alert.Heading>
                <p dangerouslySetInnerHTML={alertSuccess ? { __html: alertSuccess.body } : { __html: '' }}></p>
            </Alert>
            
            <ProviderSelect
                show={ modal_ProviderSelect_dialog_open }
                onHide={ () => setProviderSelectDialogOpen(false) }
                    size="xl"
                handleAPIRequest={ handleAPIRequest }
                service_type_id={ cashQuoteInput['serviceType'] ? cashQuoteInput['serviceType']['service_type_id'] : null }
                selected_providers={ cashQuoteInput.providers }
                onSelectProviders={ onProvidersCreate }
            />

            <div className="bg-light mt-4 mb-4 p-3">
                <Row>
                    <h1>Cash Quote</h1>
                </Row>
                <Row className="mt-3">
                    <p>You may be eligible for additional discounts or a fixed cash price at your preferred medical center through HealthRate's cash pay services.</p>
                    <p>If you would like to obtain a quote, please complete the form below, and one of our experts will promptly contact you.</p>
                </Row>
            </div>

            <div className='bg-light mt-4 mb-4 p-3'>
                <Row>
                    <h2>Service Type</h2>
                </Row>

                <Row>
                    <SimulationServiceTypeSelect
                        element_id="serviceType"
                        handleAPIRequest={ handleAPIRequest }
                        simulationInput={ cashQuoteInput }
                        setAdultPediatric={ setAdultPediatric }
                        setServiceTypeCategory={ setServiceTypeCategory }
                        setServiceType={ setServiceType }
                    />
                </Row>
            </div>

            <div className='bg-light mt-4 mb-4 p-3'>
                <Row>
                    <h2>Providers</h2>
                </Row>
                
                {cashQuoteInput.providers.map((c) => (
                    <Row 
                        className="m-3"
                        key={ `provider_id_${c.provider_id}` }
                    >
                        <h5><Button id={`provider_remove_${c.provider_id}`} onClick={() => onProviderDelete(c)} variant="outline-danger" ><XCircle /></Button> { c['provider'] }</h5>
                    </Row>
                ))}

                <div className="row border-top pt-4">
                    <div className="col-md-6 mb-sm-2 mb-2">
                        <Button id="add_provider" onClick={ onModalProviderSelectDialogOpen } disabled={ cashQuoteInput.serviceType === null } >
                            <PlusCircle /> Add Providers
                        </Button>
                    </div>
                </div>
            </div>

            <div className='bg-light mt-4 mb-4 p-3'>
                <div className="row">
                    <div className="col-md-12">
                        <Button id="cash_quote_submit"
                            onClick={ onSubmitCashQuote }
                            className="btn btn-primary"
                            style={{ width: '100px' }}
                            disabled={
                                !cashQuoteInput.serviceTypeCategory ||
                                !cashQuoteInput.serviceType ||
                                cashQuoteInput.providers.length === 0  
                            }
                        >
                            Submit
                        </Button>
                    </div>
                </div>
            </div>
    </>
    );
}
